import { Component, ElementRef, OnDestroy, ViewChild } from '@angular/core';
import { SecureFileUploadService } from '../../shared/services/secure-file-upload.service';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-secure-file-upload',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './secure-file-upload.component.html',
  styleUrl: './secure-file-upload.component.scss',
})
export class SecureFileUploadComponent implements OnDestroy {
  errormessage: string = '';
  filelbl: string = 'Browse files here';
  file: File = new File([], '');
  btnName: string = 'Upload File';
  isUploading: boolean = false;
  inputElement: HTMLInputElement | null = null;
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
  @ViewChild('errormsg', { static: false }) errormsg!: ElementRef;
  fileUploadSubscription: Subscription = new Subscription();
  constructor(private _secureFileUploadService: SecureFileUploadService) {}

  OnFileChange(event: any) {
    this.errormessage = '';
    this.file = new File([], '');
    this.filelbl = 'Browse files here';
    this.isUploading = false;
    this.file = event.target.files[0];
    if (
      (this.file?.type && this.file.type !== 'application/pdf') ||
      (this.file?.name && !this.file.name.endsWith('.pdf'))
    ) {
      this.filelbl = this.file.name;
      this.file = new File([], '');
      this.errormessage = 'Please select valid file format';
    } else if (this.file && this.file.size > 100000000) {
      this.filelbl = this.file.name;
      this.file = new File([], '');
      this.errormessage = 'File size exceeds 100 MB';
    } else {
      this.errormessage = '';
      this.filelbl = this.file?.name || 'Browse files here';
    }
  }
  secureFileUpload() {
    this.inputElement = document.querySelector('#errormsg') as HTMLInputElement;
    if (!this.file || this.file.name === '') {
      this.file = new File([], '');
      this.errormessage = 'You have not specified a file.';
      this.filelbl = 'Browse files here';
      this.announceErrorMessage(this.errormessage, 'error');
    } else if (this.file && this.file.size === 0) {
      this.file = new File([], '');
      this.errormessage = 'You have not specified a file.';
      this.filelbl = 'Browse files here';
      this.announceErrorMessage(this.errormessage, 'error');
    } else {
      this.isUploading = true;
      const formData = new FormData();
      formData.append('File', this.file, this.file.name);
      const fileName: string = this.file.name;
      formData.append('RequestingSystem', 'FinPro');
      this.fileUploadSubscription = this._secureFileUploadService.secureFileUpload(formData).subscribe({
        next: (data: any) => {
          this.isUploading = false;
          if (data.response.endsWith('successfully')) {
            this.btnName = 'Upload Another File';
            this.filelbl = 'Browse files here';
            this.file = new File([], '');
            this.errormessage = fileName + ' uploaded successfully';
            this.fileInput.nativeElement.value = '';
          } else {
            this.errormessage = data.response;
          }
          this.announceErrorMessage(this.errormessage, 'success');
        },
        error: () => {
          this.isUploading = false;
          this.errormessage = 'Error with the file upload. Please try again.';
          this.announceErrorMessage(this.errormessage, 'error');
        },
      });
    }
  }
  ngOnDestroy(): void {
    this.fileUploadSubscription.unsubscribe();
  }

  announceErrorMessage(message: string, type: string): void {
    if (this.inputElement) {
      this.announce(message).then(() => {
        if (type !== 'success') {
          const fileInput = document.querySelector('#fileLbl') as HTMLInputElement;
          fileInput.focus();
        }
      });
    }
  }

  announce(message: string): Promise<void> {
    return new Promise((resolve) => {
      const region = this.errormsg.nativeElement as HTMLElement;
      region.textContent = ''; // Clear to ensure the change is recognized
      // eslint-disable-next-line no-undef
      setTimeout(() => {
        region.textContent = message;
        if (this.inputElement) {
          this.inputElement.setAttribute('aria-live', 'assertive');
          this.inputElement.focus();
        }
        // Wait an approximate time based on message length (not accurate, just heuristic)
        const estimatedDuration = Math.max(2000, message.length * 100);
        // eslint-disable-next-line no-undef
        setTimeout(() => resolve(), estimatedDuration);
      }, 1000); // slight delay to allow clearing to register
    });
  }
}
